const styles = theme => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto"
  },
  topGrid: {
    borderBottom: "0.5px solid #D3D3D3",
    textAlign: "center",
    height: "115px"
  },
  bottomGrid: {
    textAlign: "center",
    height: "115px"
  },
  t_tar_text: {
    fontSize: "12pt",
    marginTop: theme.spacing.unit * 4
    //paddingTop: "10px !important"
  },
  t_tar_no: {
    fontSize: "12pt"
  },
  t_tar_no2: {
    fontSize: "15pt",
    fontWeight: "bold"
  },
  t_tar_text_p: {
    fontSize: "12pt",
    color: `${theme.palette.success} !important`,
    marginTop: theme.spacing.unit * 3
  },
  t_tar_no_p: {
    fontSize: "15pt",
    color: `${theme.palette.success} !important`,
    fontWeight: "bold"
  },
  t_tar_text_f: {
    fontSize: "12pt",
    color: `${theme.palette.fail} !important`,
    marginTop: theme.spacing.unit * 3
  },
  t_tar_no_f: {
    fontSize: "15pt",
    color: `${theme.palette.fail} !important`,
    fontWeight: "bold"
  }
});

export default styles;
